import { Link } from 'react-router-dom';
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-slate-900 via-purple-900 to-slate-900 shadow-lg">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/8dabc29d-8188-4a81-908f-bf6a8dda8fde.png" 
              alt="Aviator Casino Logo" 
              className="h-12 w-auto"
            />
            <span className="text-2xl font-bold text-white">Aviator Casino</span>
          </Link>

          <button
            className="lg:hidden text-white p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span className={`block h-0.5 w-full bg-white transition-all ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`block h-0.5 w-full bg-white transition-all ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-full bg-white transition-all ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </div>
          </button>

          <div className="hidden lg:flex items-center gap-8">
            <Link to="/" className="text-white hover:text-amber-400 transition-colors font-medium">
              Home
            </Link>
            <Link to="/games" className="text-white hover:text-amber-400 transition-colors font-medium">
              Games
            </Link>
            <Link to="/how-to-play" className="text-white hover:text-amber-400 transition-colors font-medium">
              How to Play
            </Link>
            <a 
              href="#play-now" 
              className="bg-gradient-to-r from-amber-500 to-orange-600 text-white px-6 py-2.5 rounded-full font-semibold hover:from-amber-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Play Now
            </a>
          </div>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-purple-700 pt-4">
            <div className="flex flex-col gap-4">
              <Link 
                to="/" 
                className="text-white hover:text-amber-400 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/games" 
                className="text-white hover:text-amber-400 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Games
              </Link>
              <Link 
                to="/how-to-play" 
                className="text-white hover:text-amber-400 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                How to Play
              </Link>
              <a 
                href="#play-now" 
                className="bg-gradient-to-r from-amber-500 to-orange-600 text-white px-6 py-2.5 rounded-full font-semibold hover:from-amber-600 hover:to-orange-700 transition-all shadow-lg text-center whitespace-nowrap"
              >
                Play Now
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
